;
( function( $, window, document, undefined )
{
    'use strict';

    var RankingUp = function( element, options )
    {
        this.$modal     = element;
        this.options    = options;
        this.$rProgress = this.$modal.find( '#ranking-up-progress' );
        this.$counter   = this.$rProgress.find( 'big' );
        this.$progress  = this.$rProgress.find( '.progress' );
        this._progress  = null;
        this._limit     = 10;
        this._duration  = 1000;
        this.init();
    };

    RankingUp.prototype = {

        init : function()
        {
            this.progressBar();

            var that = this;
            setTimeout( function()
            {
                that.show();

                setTimeout( function()
                {
                    that.counter( $( '#ranking-up-progress' ).data( 'limit' ) );
                }, 1400 );
            }, 1000 );

            $( document ).keyup( function( e )
            {
                if( e.keyCode == 27 )
                {
                    $( '#pdc6-modal-close' ).trigger( 'click' );
                }
            } );

            this.close();
        },

        show : function()
        {
            this.options.els.$body.addClass( 'with-modal' );
        },

        progressBar : function()
        {
            this._progress = window.rankingUpProgress;
        },

        counter : function( limit )
        {
            var that = this;

            this._progress.animate( 1, function()
            {
                $( '#ranking-up-rank' ).addClass( 'do-it-please' );

                var d = ( limit * that._duration ) / 39;
                that._progress.set( 0 );
                that._progress.animate( ( limit / 100 ), { duration : d }, function()
                {

                } );
            } );
        },

        close : function()
        {
            var that = this;

            $( '#pdc6-modal-close' ).on( 'click', function( e )
            {
                e && e.preventDefault();

                that.options.els.$body.removeClass( 'with-modal' );
                that.$modal.addClass( 'hide' );
            } );
        }

    };

    $.fn.RankingUp = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'RankingUp' );

        if( !instance )
        {
            instance = new RankingUp( this, options );
            $item.data( 'RankingUp', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );